import { DM_Sans, Fraunces, Inter } from 'next/font/google';

/**
 * Shared font instances for the design system. `next/font/google` is a
 * build-time macro; it is invoked here once and consumed by each app's root
 * layout via {@link fontVars}. Both apps therefore expose the same CSS custom
 * properties (`--font-fraunces`, `--font-inter`, `--font-dm-sans-google`) that
 * the `@theme` tokens in globals.css alias to `--font-heading` / `--font-ui`.
 */
export const fraunces = Fraunces({
  subsets: ['latin'],
  variable: '--font-fraunces',
  display: 'swap',
});

export const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter',
  display: 'swap',
});

// DM Sans is label/title text in the design spec. `preload: false` — it is used
// only on an in-app settings preview, so initial pages don't pay for it.
export const dmSans = DM_Sans({
  subsets: ['latin'],
  variable: '--font-dm-sans-google',
  display: 'swap',
  preload: false,
});

/** Combined font-variable className for the root `<html>` element. */
export const fontVars = `${fraunces.variable} ${inter.variable} ${dmSans.variable}`;
